import i18n from '@/lang/i18n'

export const EVENT_TYPE = {
    HOLIDAY: {
        code: 'HOLIDAY',
        translatedName: i18n.t('component.calendar.holidays'),
        classNames: 'holiday-event',
        fontColor: 'holiday-color'
    },
    LEAVE: {
        code: 'LEAVE',
        translatedName: i18n.tc('component.calendar.leave', 1),
        classNames: 'sick-event',
        fontColor: 'sick-color'
    },
    ABSENCE: {
        code: 'ABSENCE',
        translatedName: i18n.tc('component.calendar.absence', 1),
        classNames: 'absence-event',
        fontColor: 'absence-color'
    },
    PUBLIC_HOLIDAY: {
        code: 'PUBLIC_HOLIDAY',
        translatedName: i18n.tc('component.calendar.publicHoliday'),
        classNames: 'festive-event'
    },
    WEEKEND: {
        code: 'WEEKEND',
        translatedName: i18n.tc('component.calendar.noWorkingDays'),
        classNames: 'day-off'
    }
}
